import { useState } from 'react';

import {
    IconButton,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverArrow
} from '@chakra-ui/react';

import { FaCopy } from "react-icons/fa";

let popoverTimeout;

export function CopyButton ({copyText, size, bgColor}) {
    const [popoverOpen, setPopoverOpen] = useState(false);

    return(
        <Popover isOpen={popoverOpen}>
            <PopoverTrigger>
                <IconButton
                    alignSelf='center'                   
                    variant='outline'
                    icon={<FaCopy/>}
                    size={size ?? "sm"}
                    onClick={()=>{
                        clearTimeout(popoverTimeout);
                        popoverTimeout = setTimeout(()=>{
                            setPopoverOpen(false);
                        }, 1000);
                        setPopoverOpen(true);
                        navigator.clipboard.writeText(copyText);
                    }}
                />
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow bgColor={bgColor ?? "gray.700"}/>
                <PopoverBody bgColor={bgColor ?? "gray.700"}>
                    Copied <span style={{fontWeight: "bold"}}>'{copyText}'</span> to clipboard
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}